import { getRequest } from "api/axiosClient";
import { GetAttachmentsResponseType } from "api/response";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/request`;

const getAttachments = (id: string) => getRequest<GetAttachmentsResponseType>(`${baseURL}/${id}/attachments`);

// eslint-disable-next-line import/prefer-default-export
export { getAttachments };
